module.exports = __webpack_public_path__ + "img/logo-dark.527a0f39.png";